import React from 'react';
import PropTypes from 'prop-types';

export const FormattedClipProviders = ({providers}) => {
    return (
        <div style={{whiteSpace: 'pre-line'}}>
            {providers?.replaceAll('), ', ')\n')}
        </div>
    );
};

FormattedClipProviders.propTypes = {
    providers: PropTypes.string,
};

FormattedClipProviders.defaultProps = {
    providers: '',
};
